<script>
import Portfolio from './Portfolio.vue';

export default {
  name: "Portal",

  components: {Portfolio},

  props: {
    user: {
      required: false,
      default: null,
    },
    isSuper: {
      type: Boolean,
      required: false,
      default: false,
    },
    view: {
      type: Number,
      required: false,
      default: 5,
    }
  },

  data() {
    return {
      selectedView: 5,
      loadedView: sessionStorage.getItem('loadedView'),
    };
  },

  created() {
    if (this.loadedView) {
      this.selectedView = parseInt(this.loadedView)
    } else {
      this.selectedView = this.view
    }
  },

  methods: {
    setView(view) {
      this.selectedView = view;
      sessionStorage.setItem('loadedView', view);
    },
  },
}
</script>

<template>
  <div class="flex">
<!--    <div @click="setView(1)"-->
<!--         :class="this.selectedView === 1 ? 'bg-primary' : 'bg-blue text-white'"-->
<!--         class="w-1/2 md:w-1/4 text-3xl text-center tab-shadow rounded-t py-2 mr-2 hover:cursor-pointer">-->
<!--      Portfolio-->
<!--    </div>-->
<!--    <div @click="setView(2)"-->
<!--         :class="this.selectedView === 2 ? 'bg-secondary' : 'bg-blue text-white'"-->
<!--         class="w-1/2 md:w-1/4 text-3xl text-center rounded-t-md py-2 hover:cursor-pointer">-->
<!--      Area View-->
<!--    </div>-->
<!--    <div @click="setView(3)"-->
<!--         :class="this.selectedView === 3 ? 'bg-primary' : 'bg-blue text-white'"-->
<!--         class="w-1/2 md:w-1/4 text-3xl text-center tab-shadow rounded-t py-2 mr-2 hover:cursor-pointer">-->
<!--      Contracts-->
<!--    </div>-->
    <div @click="setView(4)"
         :class="this.selectedView === 4 ? 'bg-primary' : 'bg-blue text-white'"
         class="w-1/2 md:w-1/4 text-3xl text-center tab-shadow rounded-t py-2 mr-2 hover:cursor-pointer">
      Farms
    </div>
    <div @click="setView(5)"
         :class="this.selectedView === 5 ? 'bg-primary' : 'bg-blue text-white'"
         class="w-1/2 md:w-1/4 text-3xl text-center tab-shadow rounded-t py-2 mr-2 hover:cursor-pointer">
      Field Visits
    </div>
  </div>
  <div class="tile-shadow bg-primary rounded-b rounded-tr p-2">
    <Portfolio v-if="selectedView === 1"></Portfolio>
    <div v-if="selectedView === 2">Area View</div>
    <dashboard v-if="selectedView === 3" :resource="'contracts'" :default-user="this.user"></dashboard>
    <dashboard v-if="selectedView === 4" :resource="'farms'" :default-user="this.user" :model="'farm'"></dashboard>
    <dashboard v-if="selectedView === 5" :resource="'fieldVisits'" :default-user="this.user" :is-super="isSuper"></dashboard>
  </div>


</template>
